import React from 'react'
import { InlineBodyInterface } from 'common/types/inline-body-interface'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { getRootEntity } from 'client/reducers/pageReducer'
import { usePage } from 'client/store'
import { useUpdateProp } from '../hooks/useUpdateProps'
import { LanguageSelector, Width } from '../options'
import { ShadowStyle } from '../styles'
import Border from '../styles/Border'
import { Typography } from './components/typography-new'
import { Background } from './components/background'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'

export const InlineFormSettings = () => {
  // @description: for InlineBody

  const entity: InlineBodyInterface = usePage(getRootEntity)
  const updateProp = useUpdateProp(entity)
  const { isMobile } = useDeviceModeContext()

  return (
    <>
      <Width
        width={entity.maxWidth}
        update={value => updateProp('maxWidth')(Number.parseInt(value))}
      />
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
      />
      <Border
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        update={updateProp('border')}
        mobileUpdate={updateProp('mobileBorder')}
      />
      <ShadowStyle
        shadow={entity.boxShadow}
        mobileShadow={entity.mobileBoxShadow}
        update={updateProp('boxShadow')}
        mobileUpdate={updateProp('mobileBoxShadow')}
      />
      <Typography />
      <LanguageSelector />
      <Background<InlineBodyInterface> />
    </>
  )
}
